import { Factory } from 'miragejs'
const faker = require('faker');

export const campaignFactory = Factory.extend({
  id() {
      return faker.datatype.uuid()
    },
    title() {
      return faker.company.companyName()
    },
    description() {
      return faker.commerce.productDescription()
    },
    image() {
      return faker.image.imageUrl()
    },
    value() {
      return faker.datatype.number({ max: 10 })
    }
})



// WEBPACK FOOTER //
// ./src/mocks/factories/campaignFactory.js